import { style } from '@vanilla-extract/css';

export const infoListWrapperClass = style({
  width: '100%',
  minWidth: 250,
  display: 'flex',
  flexDirection: 'column',
});
